import { BaseModel } from "@/models/base/BaseModel";

export class AdditionalServiceCategory extends BaseModel {
  categories: string[] = [];
}
